document.addEventListener('click', function (e) {
  const btn = e.target.closest('.wt-product-tabs__btn');
  if (!btn) return;

  const root = btn.closest('.wt-product-tabs');
  if (!root) return;

  const targetId = btn.getAttribute('data-tab-target');

  root.querySelectorAll('.wt-product-tabs__btn').forEach(b => {
    b.classList.remove('is-active');
    b.setAttribute('aria-selected', 'false');
  });

  root.querySelectorAll('.wt-product-tabs__panel').forEach(p => {
    p.classList.remove('is-active', 'is-animating');
  });

  btn.classList.add('is-active');
  btn.setAttribute('aria-selected', 'true');

  const panel = root.querySelector('#' + targetId);
  if (panel) {
    panel.classList.add('is-active');

    void panel.offsetWidth;

    panel.classList.add('is-animating');
  }
});
